import * as React from 'react';

import { useApolloClient } from '@apollo/client';

import {
  GetAvailabilityAndPriceQueryQuery,
  GetAvailabilityAndPriceQueryQueryVariables,
} from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import getAvailabilityAndPrice from './queries/getAvailabilityAndPriceQuery.graphql';

export const useGetProductById = () => {
  const { query } = useApolloClient();
  const { swogoIgnoreConvertedPrice } = useFeatureFlags();

  return React.useCallback(
    async (productId: string | number) =>
      query<
        GetAvailabilityAndPriceQueryQuery,
        GetAvailabilityAndPriceQueryQueryVariables
      >({
        query: getAvailabilityAndPrice,
        variables: {
          id: String(productId),
        },
        fetchPolicy: 'cache-first',
      })
        .then((res) => res.data.vpProductById)
        .then((product) =>
          product
            ? {
                ...product,
                recommendedPrice:
                  swogoIgnoreConvertedPrice &&
                  product.recommendedPrice?.isConverted
                    ? null
                    : product.recommendedPrice,
              }
            : null
        ),
    [query, swogoIgnoreConvertedPrice]
  );
};
